/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  V1GetSecurityAdvisorsParams,
  V1ProjectAdvisorsResponse
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * This is an **experimental** endpoint. It is subject to change or removal in future versions. Use it with caution, as it may not remain supported or stable.
 * @deprecated
 * @summary Gets project performance advisors.
 */
export type v1GetPerformanceAdvisorsResponse200 = {
  data: V1ProjectAdvisorsResponse
  status: 200
}

export type v1GetPerformanceAdvisorsResponse401 = {
  data: void
  status: 401
}

export type v1GetPerformanceAdvisorsResponse403 = {
  data: void
  status: 403
}

export type v1GetPerformanceAdvisorsResponse429 = {
  data: void
  status: 429
}

export type v1GetPerformanceAdvisorsResponseSuccess = (v1GetPerformanceAdvisorsResponse200) & {
  headers: Headers;
};
export type v1GetPerformanceAdvisorsResponseError = (v1GetPerformanceAdvisorsResponse401 | v1GetPerformanceAdvisorsResponse403 | v1GetPerformanceAdvisorsResponse429) & {
  headers: Headers;
};

export type v1GetPerformanceAdvisorsResponse = (v1GetPerformanceAdvisorsResponseSuccess | v1GetPerformanceAdvisorsResponseError)

export const getV1GetPerformanceAdvisorsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/advisors/performance`
}

export const v1GetPerformanceAdvisors = async (ref: string, options?: RequestInit): Promise<v1GetPerformanceAdvisorsResponse> => {
  
  return customFetch<v1GetPerformanceAdvisorsResponse>(getV1GetPerformanceAdvisorsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * This is an **experimental** endpoint. It is subject to change or removal in future versions. Use it with caution, as it may not remain supported or stable.
 * @deprecated
 * @summary Gets project security advisors.
 */
export type v1GetSecurityAdvisorsResponse200 = {
  data: V1ProjectAdvisorsResponse
  status: 200
}

export type v1GetSecurityAdvisorsResponse401 = {
  data: void
  status: 401
}

export type v1GetSecurityAdvisorsResponse403 = {
  data: void
  status: 403
}

export type v1GetSecurityAdvisorsResponse429 = {
  data: void
  status: 429
}

export type v1GetSecurityAdvisorsResponseSuccess = (v1GetSecurityAdvisorsResponse200) & {
  headers: Headers;
};
export type v1GetSecurityAdvisorsResponseError = (v1GetSecurityAdvisorsResponse401 | v1GetSecurityAdvisorsResponse403 | v1GetSecurityAdvisorsResponse429) & {
  headers: Headers;
};

export type v1GetSecurityAdvisorsResponse = (v1GetSecurityAdvisorsResponseSuccess | v1GetSecurityAdvisorsResponseError)

export const getV1GetSecurityAdvisorsUrl = (ref: string,
    params?: V1GetSecurityAdvisorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/advisors/security?${stringifiedParams}` : `/v1/projects/${ref}/advisors/security`
}

export const v1GetSecurityAdvisors = async (ref: string,
    params?: V1GetSecurityAdvisorsParams, options?: RequestInit): Promise<v1GetSecurityAdvisorsResponse> => {
  
  return customFetch<v1GetSecurityAdvisorsResponse>(getV1GetSecurityAdvisorsUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

